import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'

export interface RouterProps {}

export const useRouter = (props: RouterProps) => {
  const isLoadingHome = useSelector((state: RootState) => state.home.isLoading)
  const isLoadingAbout = useSelector(
    (state: RootState) => state.about.isLoading
  )
  const isLoadingBranches = useSelector(
    (state: RootState) => state.branches.isLoading
  )
  const isLoadingTeam = useSelector((state: RootState) => state.team.isLoading)
  const isLoadingPosts = useSelector(
    (state: RootState) => state.posts.isLoading
  )

  const isLoading =
    isLoadingHome &&
    isLoadingAbout &&
    isLoadingBranches &&
    isLoadingTeam &&
    isLoadingPosts

  return {
    ...props,
    isLoading,
  }
}
